import { Box, Button } from '@mui/material'
import type { ContentPageNumber } from '../add-visit-flow'

export function FooterButtons({
  onClose,
  onSave,
  onNext,
  onPrevious,
  active,
  arePagesValid,
  pages,
}: {
  onClose: () => void
  onSave: () => void
  onNext: () => void
  onPrevious: () => void
  active: ContentPageNumber
  arePagesValid: boolean
  pages: ContentPageNumber[]
}) {
  const isLastPage = active === pages[pages.length - 1]
  const isFirstPage = active === pages[0]
  return (
    <Box sx={{ display: 'flex', gap: 3, justifyContent: 'end' }}>
      <Button color="error" onClick={onClose}>
        Cancel
      </Button>
      {!isLastPage && (
        <Button variant="contained" onClick={onNext} disabled={!arePagesValid}>
          Next
        </Button>
      )}
      {!isFirstPage && <Button onClick={onPrevious}>Previous</Button>}
      {isLastPage && (
        <Button variant="contained" onClick={onSave}>
          Save
        </Button>
      )}
    </Box>
  )
}
